module.exports = __webpack_public_path__ + "static/media/md-logo.040b6552.png";